// --------------------------------------------------
//
// ライブラリインポート
//
// --------------------------------------------------

//lenis
import Lenis from '@studio-freight/lenis';

//gsap
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CSSPlugin from 'gsap/CSSPlugin';
gsap.registerPlugin(ScrollTrigger, CSSPlugin);

//swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);



// --------------------------------------------------
//
// グローバル変数
//
// --------------------------------------------------

// グローバル変数
let lenis;
let rafId = null;
let scrollTop = 0; // スクロール位置を保持する変数
let lastScrollY = 0; // ヘッダースクロールアニメーション用

// DOM要素のキャッシュ
const body = document.querySelector('body');
const header = document.querySelector('.fixed-header');
const LPheader = document.querySelector('.lower__lp__header');
const headerHam = document.querySelector('.ham-menu');
const headerHamOverlay = document.querySelector('.ham-overlay');
const headerMenuBtn = document.querySelector('.header-btn');
const lpMenuTarget = document.querySelector('.lower__lp__header__nav');
const lpHeaderBtn = document.querySelector('.lower__lp__header__menuBtn');
const footer = document.querySelector('.footer');

// スクロールバーの幅を設定する関数
const setScrollbarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
};

// Lenisスクロールを初期化・開始する関数
const initLenis = () => {
	if (!lenis) { // Lenisがまだ初期化されていなければ初期化
		lenis = new Lenis();
	}
	function raf(time) {
		lenis.raf(time);
		rafId = requestAnimationFrame(raf);
	}
	if (!rafId) { // 既に動いている場合は何もしない
		rafId = requestAnimationFrame(raf);
	}
};

// Lenisスクロールを停止する関数
const stopLenis = () => {
	if (rafId) {
		cancelAnimationFrame(rafId);
		rafId = null;
	}
};

// ヘッダーの高さを取得する関数
const getHeaderHeight = () => {
	let height = header ? header.offsetHeight : 0;
	if (LPheader) {
		height += LPheader.offsetHeight;
	}
	return height;
};

// スクロール復元とアンロード時の処理
history.scrollRestoration = "manual";
window.addEventListener('beforeunload', () => {
	window.scrollTo(0, 0);
});

// 初期ロード時のLenisの開始
if (window.innerWidth > 767) {
	initLenis();
}

/*
------------------------


*/

//heroスクロールアニメーション
const initHeroScrollAnimation = () => {
	const hero = document.querySelector('.hero');
	const heroTitle = document.querySelector('.hero-title');
	const heroSubItems = document.querySelectorAll('.hero-sub .inner');
	const heroBanner = document.querySelector('.hero-bnr');

	if (!hero || !heroTitle || !heroSubItems.length || !heroBanner) return;

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: hero,
			start: "top-=1px top",
			invalidateOnRefresh: false,
		}
	});

	tl.fromTo(heroSubItems, {
		yPercent: 9,
		autoAlpha: 0,
	}, {
		yPercent: 0,
		autoAlpha: 1,
		duration: 0.7,
		ease: "circ.out",
		stagger: {
			each: 0.3,
			from: 'start',
		}
	}).fromTo(heroTitle, {
		scale: 1.06,
		blur: 0.2,
		autoAlpha: 0,
	}, {
		scale: 1,
		blur: 0,
		autoAlpha: 1,
		duration: 1.4,
		ease: "expo.out",
	}, "<=1").fromTo(heroBanner, {
		yPercent: 10,
		autoAlpha: 0,
	}, {
		yPercent: 0,
		autoAlpha: 1,
		duration: 1.2,
		ease: "expo.out",
	}, "<=0.7");
};
let heroSliderInstance = null;

let currentType = null; // "pc" or "sp"

// スライダー初期化関数
const createHeroSlider = (container) => {
	return new Swiper(container, {
		loop: true,
		speed: 5000,
		autoplay: { delay: 5000 },
		effect: 'fade',
		fadeEffect: { crossFade: true }
	});
};

// スライダー制御関数
const setupResponsiveHeroSlider = () => {
	const pcSlider = document.querySelector(".hero__bg--pc");
	const spSlider = document.querySelector(".hero__bg--sp");

	if (!pcSlider && !spSlider) return;

	// aria-hidden一括管理
	const setAria = (active, inactive) => {
		if (active) active.setAttribute("aria-hidden", "false");
		if (inactive) inactive.setAttribute("aria-hidden", "true");
	};

	// 表示幅による切り替えロジック
	const updateSlider = () => {
		const isPC = window.innerWidth >= 768;

		if (isPC && currentType !== "pc") {
			// PC用を有効化、SP用を無効化
			if (heroSliderInstance) {
				heroSliderInstance.destroy(true, true);
				heroSliderInstance = null;
			}
			if (pcSlider) {
				heroSliderInstance = createHeroSlider(pcSlider);
				setAria(pcSlider, spSlider);
			}
			currentType = "pc";
		}
		if (!isPC && currentType !== "sp") {
			// SP用を有効化、PC用を無効化
			if (heroSliderInstance) {
				heroSliderInstance.destroy(true, true);
				heroSliderInstance = null;
			}
			if (spSlider) {
				heroSliderInstance = createHeroSlider(spSlider);
				setAria(spSlider, pcSlider);
			}
			currentType = "sp";
		}
	};

	// 初回実行
	updateSlider();

	// リサイズ監視
	window.addEventListener("resize", () => {
		updateSlider();
	});
};



//
const initAboutScrollAnimation = () => {
	const aboutTop = document.querySelector('.about__top');
	const aboutImgs = document.querySelectorAll('.about__top-pic li');
	// 画像は3つ以上必要
	if (!aboutTop || aboutImgs.length < 3) return;

	// GSAPタイムライン
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: aboutTop,
			start: "top top",
			end: `top+=${window.innerHeight * 4}px bottom`,
			invalidateOnRefresh: false,
			scrub: true,
			pin: true,
		}
	});

	// 各画像に順にアニメーション設定
	tl.fromTo(aboutImgs[0], {
		yPercent: 15,
		xPercent: -10,
		rotate: -14,
		autoAlpha: 0,
	}, {
		yPercent: 0,
		xPercent: 0,
		rotate: 7,
		autoAlpha: 1,
		delay: 2,
		duration: 2.4,
	})
		.fromTo(aboutImgs[1], {
			yPercent: 15,
			xPercent: 10,
			rotate: -27,
			autoAlpha: 0,
		}, {
			yPercent: 0,
			xPercent: 0,
			rotate: -13,
			autoAlpha: 1,
			duration: 2.4,
		})
		.fromTo(aboutImgs[2], {
			yPercent: 15,
			xPercent: 10,
			rotate: 15,
			autoAlpha: 0,
		}, {
			yPercent: 0,
			xPercent: 0,
			rotate: -2,
			autoAlpha: 1,
			duration: 2.4,
		});
};




/**
 * 指定した要素が画面内に入った時だけSwiperを生成し、画面外でdestroyする
 * @param {string} selector - スライダーのセレクタ
 * @param {Object} options - Swiperの初期化オプション
 */
const setupScrollSwiper = (selector, options) => {
	let instance = null;
	const el = document.querySelector(selector);
	if (!el) return;

	ScrollTrigger.create({
		trigger: el,
		start: "top bottom",     // 画面下に入った瞬間
		end: "bottom top",       // 画面上から出た瞬間
		onEnter: () => {
			if (!instance) {
				instance = new Swiper(el, options);
			}
		},
		onLeave: () => {
			if (instance) {
				instance.destroy(true, true);
				instance = null;
			}
		},
		onEnterBack: () => {
			if (!instance) {
				instance = new Swiper(el, options);
			}
		},
		onLeaveBack: () => {
			if (instance) {
				instance.destroy(true, true);
				instance = null;
			}
		}
	});
};

const setupAllSwipers = () => {
	// image-slide
	setupScrollSwiper(".image-slide", {
		loop: true,
		slidesPerView: "auto",
		speed: 20000,
		allowTouchMove: false,
		autoplay: { delay: 0 }
	});


};
// planSlide1
new Swiper('.results__cont-slide1', {
	speed: 700,
	slidesPerView: 1,
	pagination: {
		el: '.results__cont-slide1 .swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: ".results__cont-slide1 .swiper-button-next",
		prevEl: ".results__cont-slide1 .swiper-button-prev",
	},
});

// planSlide2
new Swiper('.results__cont-slide2', {
	speed: 700,
	slidesPerView: 1,
	pagination: {
		el: '.results__cont-slide2 .swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: ".results__cont-slide2 .swiper-button-next",
		prevEl: ".results__cont-slide2 .swiper-button-prev",
	},
});

// accessSlide1
new Swiper('.access__slide-cont1 .swiper', {
	speed: 700,
	slidesPerView: 1,
	pagination: {
		el: '.access__slide-cont1 .swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: ".access__slide-cont1 .swiper-button-next",
		prevEl: ".access__slide-cont1 .swiper-button-prev",
	},
});

// accessSlide2
new Swiper('.access__slide-cont2 .swiper', {
	speed: 700,
	slidesPerView: 1,
	pagination: {
		el: '.access__slide-cont2 .swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: ".access__slide-cont2 .swiper-button-next",
		prevEl: ".access__slide-cont2 .swiper-button-prev",
	},
});


const kengakuCheck = document.querySelector('input[name="kengaku[]"]');
if (kengakuCheck) {
	kengakuCheck.addEventListener('change', () => {
		if (kengakuCheck.checked) {
			document.querySelector('.kengaku-inner').setAttribute('aria-hidden', 'false');
		} else {
			document.querySelector('.kengaku-inner').setAttribute('aria-hidden', 'true');
		}
	});
}

const siryoCheck = document.querySelector('input[name="siryo[]"]');
if (siryoCheck) {
	siryoCheck.addEventListener('change', () => {
		if (siryoCheck.checked) {
			document.querySelector('.siryo-inner').setAttribute('aria-hidden', 'false');
		} else {
			document.querySelector('.siryo-inner').setAttribute('aria-hidden', 'true');
		}
	});
}

const okotsuCheck = document.querySelectorAll('input[name="siryo_ikotsu"]');
if (okotsuCheck) {
	okotsuCheck.forEach(item => {
		item.addEventListener('change', () => {
			if (document.getElementById("siryo_ikotsu3").checked) {
				document.querySelector('#siryo_genchi').setAttribute('aria-hidden', 'false');
			} else {
				document.querySelector('#siryo_genchi').setAttribute('aria-hidden', 'true');
				document.querySelector('#siryo_inaka').setAttribute('aria-hidden', 'true');
			}
		});
	});
}

const genchiCheck = document.querySelectorAll('input[name="siryo_genchi"]');
if (genchiCheck) {
	genchiCheck.forEach(item => {
		item.addEventListener('change', () => {
			if (document.getElementById("siryo_genchi1").checked) {
				document.querySelector('#siryo_inaka').setAttribute('aria-hidden', 'false');
			} else {
				document.querySelector('#siryo_inaka').setAttribute('aria-hidden', 'true');
			}
		});
	});
}



// ヘッダーメニューの制御
const setupHeaderMenu = () => {
	if (headerMenuBtn && headerHam) {
		headerMenuBtn.addEventListener("click", () => {
			const isExpanded = headerMenuBtn.getAttribute('aria-expanded') === "false";

			headerMenuBtn.setAttribute('aria-label', isExpanded ? 'メニューを閉じる' : 'メニューを開く');
			headerMenuBtn.setAttribute('aria-expanded', isExpanded);
			headerHam.setAttribute('aria-hidden', !isExpanded);

			if (isExpanded) {
				scrollTop = window.scrollY; // 現在のスクロール位置を保存
				//.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
				body.style.top = `${scrollTop * -1}px`;
				body.classList.add('fixed');

				headerHamOverlay.classList.add('--active');

				gsap.to(headerHam, {
					ease: "expo.out",
					duration: .56,
					xPercent: -100,
					// will-changeを適用し、アニメーション終了後に解除
					onStart: () => gsap.set(headerHam, { willChange: 'transform' }),
					onComplete: () => gsap.set(headerHam, { willChange: 'auto' })
				});

				if (window.innerWidth > 767) {
					stopLenis();
				}
			} else {
				body.classList.remove('fixed');
				body.style.top = 'inherit';
				//window.scrollTo(0, scrollTop); // 保存したスクロール位置に戻る
				headerHamOverlay.classList.remove('--active');

				gsap.to(headerHam, {
					ease: "expo.out",
					duration: .56,
					xPercent: 0,
					onStart: () => gsap.set(headerHam, { willChange: 'transform' }),
					onComplete: () => gsap.set(headerHam, { willChange: 'auto' })
				});
				//body.style.paddingRight = '0px';

				if (window.innerWidth > 767) {
					initLenis(); // stopLenisではなくinitLenisを呼び出すことで、停止していれば再開
				}

				console.log(scrollTop);
				window.scrollTo(0, scrollTop);
			}
		});
	}

	// ヘッダーメニュー内部のドロップダウンボタン
	document.querySelectorAll('.header__ham__list button.inner').forEach(btn => {
		btn.addEventListener('click', () => {
			const isExpanded = btn.getAttribute('aria-expanded') === "false";
			btn.setAttribute('aria-expanded', isExpanded);
			if (btn.nextElementSibling) {
				btn.nextElementSibling.setAttribute('aria-hidden', !isExpanded);
			}
		});
	});

	// ヘッダードロップダウンメニュー (PC版)
	document.querySelectorAll('.--js-drop').forEach(btn => {
		btn.addEventListener('click', () => {
			const dropLink = btn.querySelector("a");
			const dropInner = btn.querySelector(".--js-drop__inner");

			const isExpanded = headerMenuBtn.getAttribute('aria-expanded') === "false";

			headerMenuBtn.setAttribute('aria-label', isExpanded ? 'メニューを閉じる' : 'メニューを開く');
			headerMenuBtn.setAttribute('aria-expanded', isExpanded);
			headerHam.setAttribute('aria-hidden', !isExpanded);

			if (isExpanded) {
				scrollTop = window.scrollY; // 現在のスクロール位置を保存
				//.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
				body.style.top = `${scrollTop * -1}px`;
				body.classList.add('fixed');

				headerHamOverlay.classList.add('--active');

				gsap.to(headerHam, {
					ease: "expo.out",
					duration: .56,
					xPercent: -100,
					// will-changeを適用し、アニメーション終了後に解除
					onStart: () => gsap.set(headerHam, { willChange: 'transform' }),
					onComplete: () => gsap.set(headerHam, { willChange: 'auto' })
				});

				if (window.innerWidth > 767) {
					stopLenis();
				}
			} else {
				body.classList.remove('fixed');
				body.style.top = 'inherit';
				//window.scrollTo(0, scrollTop); // 保存したスクロール位置に戻る
				headerHamOverlay.classList.remove('--active');

				gsap.to(headerHam, {
					ease: "expo.out",
					duration: .56,
					xPercent: 0,
					onStart: () => gsap.set(headerHam, { willChange: 'transform' }),
					onComplete: () => gsap.set(headerHam, { willChange: 'auto' })
				});
				//body.style.paddingRight = '0px';

				if (window.innerWidth > 767) {
					initLenis(); // stopLenisではなくinitLenisを呼び出すことで、停止していれば再開
				}

				console.log(scrollTop);
				window.scrollTo(0, scrollTop);
			}
		});
	});
};

// LPヘッダーメニューの制御
const setupLPHeaderMenu = () => {
};

// アンカーリンクのスクロール処理
const setupAnchorLinks = () => {
	const anchorLinks = document.querySelectorAll('a[href*="#"]:not(.noAnchor)');
	const hamAnchorLinks = document.querySelectorAll('a.noAnchor');

	// ロード時にハッシュがある場合のスクロール
	if (location.hash) {
		const targetElement = document.querySelector(location.hash);
		if (targetElement) {
			const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
			const totalScrollAmount = targetOffsetTop - getHeaderHeight();
			// smooth behaviorを直接scrollToに渡すことで、Lenisと競合しないようにする
			window.scrollTo({
				top: totalScrollAmount,
				behavior: "smooth",
			});
		}
	}

	// アンカーリンククリック時のスクロール
	anchorLinks.forEach(link => {
		link.addEventListener('click', e => {
			const url = new URL(link.href);
			const currentUrl = new URL(window.location.href);

			// 同じオリジンかつ、パスが同じであるかチェック
			// または、パスがない場合は現在のパスとみなす
			const isSamePath = url.pathname === currentUrl.pathname || url.pathname === '/'; // ルートパスの場合は現在のパスとみなすなど、適宜調整

			if (url.origin === currentUrl.origin && isSamePath && url.hash) {
				// 同じページ内のアンカー、または同じパスへのアンカー
				e.preventDefault(); // デフォルトのジャンプをキャンセル

				const targetId = url.hash;
				const targetElement = document.querySelector(targetId);

				if (targetElement) {
					const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
					// getHeaderHeight() が定義されている前提
					const totalScrollAmount = targetOffsetTop - (typeof getHeaderHeight === 'function' ? getHeaderHeight() : 0);

					window.scrollTo({
						top: totalScrollAmount,
						behavior: "smooth",
					});
				}
			}
		});
	});

	// ハンバーガー内部のアンカーリンククリック時のスクロール
	hamAnchorLinks.forEach(link => {
		link.addEventListener('click', e => {
			const url = new URL(link.href);
			const targetId = url.hash;
			const targetElement = document.querySelector(targetId);

			if (targetElement) {

				link.blur();
				e.preventDefault();

				body.classList.remove('fixed');
				body.style.top = 'inherit';
				window.scrollTo(0, scrollTop); // 保存したスクロール位置に戻る

				gsap.to(headerHam, {
					ease: "expo.out",
					duration: .56,
					xPercent: 0,
					onStart: () => gsap.set(headerHam, { willChange: 'transform' }),
					onComplete: () => gsap.set(headerHam, { willChange: 'auto' })
				});
				body.style.paddingRight = '0px';

				if (window.innerWidth > 767) {
					initLenis(); // stopLenisではなくinitLenisを呼び出すことで、停止していれば再開
				}

				headerMenuBtn.setAttribute('aria-label', 'メニューを閉じる');
				headerMenuBtn.setAttribute('aria-expanded', "false");
				headerHam.setAttribute('aria-hidden', "true");

				const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
				const totalScrollAmount = targetOffsetTop - (typeof getHeaderHeight === 'function' ? getHeaderHeight() : 0);

				window.scrollTo({
					top: totalScrollAmount,
					behavior: "smooth",
				});
			}
		});
	});
};

// ヘッダーのスクロールアニメーション
const setupHeaderScrollAnimation = () => {
	if (!headerMenuBtn) return;
	ScrollTrigger.create({
		trigger: ".pagenav",
		start: "top top",
		onEnter: () => headerMenuBtn?.classList.add('--active'),
		onLeaveBack: () => headerMenuBtn?.classList.remove('--active')
	});
};


// アニメーション
const setupPageAnimations = () => {
	const pageYanim = document.querySelectorAll('.--fadeAnim');

	pageYanim.forEach((elem) => {
		gsap.from(elem, {
			opacity: 0,
			y: 40,
			duration: 0.8,
			ease: "power2.out",
			scrollTrigger: {
				trigger: elem,
				start: "top " + window.innerHeight * .8,
				toggleActions: "play none none none",
			}
		});
	});

};

// アニメーション
const setupResultsShow = () => {
	const results = document.querySelectorAll('.results__cont');

	results.forEach((elem) => {
		const resultTitle = elem.querySelector('.results__cont-title');
		const resultCont = elem.querySelector('.results__cont-inner');
		const resultBottom = elem.querySelector('.results__cont-bottom');


		if (window.innerWidth < 768) {
			if (!elem.classList.contains("--active")) {
				resultCont.setAttribute("aria-hidden", "true");
				resultBottom.setAttribute("aria-hidden", "true");
			}


			resultTitle.addEventListener('click', () => {
				resultCont.setAttribute("aria-hidden", "true");
				resultBottom.setAttribute("aria-hidden", "true");


				const isExpanded = resultTitle.getAttribute('aria-expanded') === "false";
				resultTitle.setAttribute('aria-expanded', isExpanded);
				if (resultTitle.nextElementSibling) {
					resultTitle.nextElementSibling.setAttribute('aria-hidden', !isExpanded);
				}
			});
		}
	});

};

const setupAccessShow = () => {
	if (window.innerWidth >= 768) {
		return;
	}
	const access = document.querySelectorAll('.access__sec');

	access.forEach((elem) => {
		elem.removeAttribute('open');
		const accessTitle = elem.querySelector('.access__sec-title');
		const accessCont = elem.querySelector('.access__sec-inner');
	});

};

// ドキュメントロード後の処理
window.addEventListener("pageshow", () => {
	initHeroScrollAnimation();
	setupResponsiveHeroSlider();
	initAboutScrollAnimation();
	setupAllSwipers();
	setupHeaderScrollAnimation();
	setScrollbarWidth();
	setupResultsShow();
	setupHeaderMenu();
	setupAccessShow();
	setupAnchorLinks();
	setupHeaderScrollAnimation();
	setupPageAnimations();
});

// リサイズ時の処理 - スロットリングを適用
let resizeTimeout;
window.addEventListener("resize", () => {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(() => {
		setScrollbarWidth();
		ScrollTrigger.refresh(true); // スクロールトリガーを強制的にリフレッシュ
		// 必要に応じてlenis.resize()も呼び出す (Lenisは自動で処理することが多い)
		if (lenis) {
			lenis.resize();
		}
		// リサイズ後にヘッダーのアニメーション状態をリセットしたい場合は追加
		if (window.innerWidth <= 700 && header) {
			gsap.set(header, { yPercent: 0 });
			gsap.set(header.querySelector('.base-width'), { paddingTop: 'auto', paddingBottom: 'auto' });
		}
	}, 100);
});
document.querySelectorAll('.demoVideo').forEach(video => {
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				video.play();
			} else {
				video.pause();
			}
		});
	}, { threshold: 0.2 }); // 30%見えたら再生

	observer.observe(video);
});
